import eventBus from "@/eventBus";
import apiService from "@/services/apiService";
import { OPEN_SNACKBAR } from "@/utils/contants";

export default {
    components: {},

    props: {
        dialog: {
            default: false
        },
        isDisabled: {
            default: false,
        },
        userJob: {
            default: null
        }
    },

    watch: {
        dialog(val) {
            if (val && !this.isDisabled) this.retrieveJobs();
        }
    },

    data() {
        return {
            loading: false,
            cardWidth: 600,
            search: null,
            userJobEdit: null,
            availableJobs: []
        };
    },

    created() {
        this.setCardWidth()
        window.addEventListener("resize", this.setCardWidth, { passive: true });
        this.userJobEdit = this.userJob;
    },

    mounted() { },

    methods: {
        setCardWidth() {
            if (window.innerWidth < 960) this.cardWidth = window.innerWidth - 80;
            else this.cardWidth = 600;
        },

        close() {
            this.userJobEdit = this.userJob;
            this.$emit('update:dialog', false)
        },

        async actionHandler() {
            this.loading = true
            try {
                const request = await apiService.put(`/agents/${this.$route.params.id}?action=job`, {
                    userJob: this.userJobEdit == null ? null : this.userJobEdit.id
                });
                const response = await request.json();
                if (!request.ok) throw new Error(response.message);
                eventBus.$emit(OPEN_SNACKBAR, {message: response.message,isError: false,})
                this.$emit("refresh")
                this.$emit('update:dialog', false)
            } catch (error) {
                eventBus.$emit(OPEN_SNACKBAR, {
                    message: error.message ?? "Veuillez réessayer ultérieurement",
                    isError: true,
                })
            } finally {
                this.loading = false
            }
        },
        async retrieveJobs() {
            this.loading = true
            try {
                const request = await apiService.get("/jobs");
                const response = await request.json();
                if (!request.ok) throw new Error(response.message);
                this.availableJobs = response.data;
            } catch (error) {
                this.availableJobs = [];
            } finally {
                this.loading = false
            }
        },
    },
};